export const CHANGE_STATUS = 'CHANGE_STATUS'
export const CHANGE_MASS_STATUS = 'CHANGE_MASS_STATUS'
export const CANCEL = 'CANCEL'
export const DETAILS = 'DETAILS'
export const FAIL_DETAILS = 'FAIL_DETAILS'
export const ERROR_DETAILS = 'ERROR_DETAILS'
export const EDIT_EXPIRY = 'EDIT_EXPIRY'
